import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {useHistory} from "react-router-dom";

const BaseButton = ({action, caption, disabled, outline, icon, link,href, light, blue, darkBlue,iconLeft,className, children, nokb}) => {
const button = useRef()
    const history = useHistory();
    const handleClick = (e) => {
        if (e) { e.preventDefault() }
        if (action) {
            action()
        } else if (link !== undefined) {
            history.push(link);
        } else if (href !== undefined) {
            window.open(href, '_blank').focus();
        }
    }
    useEffect(() => {
        !disabled && enterKeyHandler()
    }, [disabled])

      const keyValid = (e) => {
        if (e.keyCode === 13 && !disabled && !nokb) {
            document.removeEventListener("keydown", keyValid);
            if (button && button.current) button.current.click()
        }
    }
    const enterKeyHandler = () => {
        document.addEventListener('keydown', keyValid)
    }
    

    let clname = className ? className + " base-button" : " base-button"
    if (disabled) clname += " disabled"
    if (outline) clname += " outline"
    if (light) clname += " light"
    if (blue) clname += " light blue"
    if (darkBlue) clname += " light dark-blue"
    if (iconLeft) clname += " icon-left"

    if (light) {
        return (
        <button className={clname} disabled={disabled} onClick={handleClick}>
            {children}
            {caption && <div> {caption}</div>}
            {icon && <div className={`icon fonticons-${icon}`}></div>}
        </button>
        )
    } else {
         return (

        <button className={clname} disabled={disabled} onClick={handleClick} ref={button}>
            {children}
            {caption && <div> {caption}</div>}
            {icon && <div className={`icon fonticons-${icon}`}></div>}
        </button>
    )
    }
   

};

BaseButton.propTypes = {
    caption: PropTypes.any,
    disabled: PropTypes.bool,
    outline: PropTypes.bool,
    light: PropTypes.bool,
    action: PropTypes.func,
    link: PropTypes.string,
    icon: PropTypes.any,
    iconLeft: PropTypes.bool,
    className: PropTypes.string,

};

export default BaseButton
